import React, { useState } from 'react'
import { Box, Divider, Rating, Skeleton, Typography } from '@mui/material'
import { SHOW_RATINGS } from '../../../Infrastructure/Constants/ratingsState'
import CourseVector from '../../../Assets/Images/courseVector.png'
import { courseCardSx } from './styles'

export const CourseCard = ({ courseId, courseDetails, user, stars, reviews, onClick, enableFilter}) => {
    const title = courseDetails?.basics?.title
    const subTitle = courseDetails?.basics?.subTitle
    const educatorName = `${user?.account?.first_name} ${user?.account?.last_name}`
    const cost = courseDetails?.basics?.cost
    const category = courseDetails?.basics?.category
    const courseImage = courseDetails?.details?.course_image
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imgSrc, setImgSrc] = useState(courseImage || CourseVector);
    const handleImageError = () => {
        setImgSrc(CourseVector);
        setImageLoaded(true);
    }
    return (
        <Box key={courseId} sx={courseCardSx.container} onClick={onClick}>
            <Box display="flex" flexDirection={{ sm: "row", xs: "column" }} width="100%" gap={3}>
                <Box sx={courseCardSx.imageBox}>
                    {!imageLoaded && imgSrc !== CourseVector && (
                        <Skeleton variant="rectangular" width="100%" height="100%" sx={courseCardSx.skeleton} />
                    )}
                    <img
                        width={"100%"}
                        height={'100%'}
                        src={imgSrc}
                        onError={handleImageError}
                        onLoad={() => setImageLoaded(true)}
                        alt='not found'
                        style={{
                            borderRadius: '15px',
                            objectFit: 'cover',
                            aspectRatio: "16 / 9",
                            display: imageLoaded ? 'block' : 'none'
                        }}
                    />
                </Box>
                <Box sx={{ ...courseCardSx.detailsBox, width: { xs: '100%', sm: enableFilter ? '70%' : '80%' },}}>
                    <Box>
                        <Typography color="initial" sx={courseCardSx.categoryText}>{category}</Typography>
                        <Box display={'flex'} justifyContent={'space-between'}>
                            <Typography color="initial" sx={courseCardSx.titleText}>{title?.length > 60 ? `${title.slice(0,60)}...` : title}</Typography>
                            <Box sx={courseCardSx.costBox}>
                                <Typography sx={courseCardSx.costText}>${cost}</Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Typography color="initial" sx={courseCardSx.subTitleText}>{subTitle}</Typography>
                    <Typography color="grey" sx={courseCardSx.educatorText}>{educatorName}</Typography>
                    <Box sx={{...courseCardSx.ratingsBox,  display: SHOW_RATINGS ? "flex" : "none"}}>
                        <Typography color="initial" sx={courseCardSx.starsText}>{stars}</Typography>
                        <Rating name="read-only" value={stars} readOnly />
                        <Typography color="grey" sx={courseCardSx.reviewsText}>({reviews})</Typography>
                    </Box>
                </Box>
            </Box>
            <Divider sx={courseCardSx.divider} />
        </Box>
    )
}